import {
    Chart,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartSeriesItemTooltip,
    ChartTooltip,
    ChartValueAxis,
    ChartValueAxisItem,
    TooltipContext
  } from "@progress/kendo-react-charts";
  import * as moment from "moment";
  import * as React from "react";
  
import IMessageTotalsByMonthResponse from "../../types/IMessageTotalsByMonthResponse";

import { ITranslationProps, translateComponent } from "../../helpers/translation";

interface IMessageTotalsByMonthChartProps extends ITranslationProps {
    messageTotals: IMessageTotalsByMonthResponse[]
}

class MessageTotalsByMonthChart extends React.Component<IMessageTotalsByMonthChartProps> {

    constructor(props: IMessageTotalsByMonthChartProps) {
        super(props);

        this.state = {
            categories: [],
        };
    }

    public render() {
        if (this.props.messageTotals === null || this.props.messageTotals.length === 0) {
            return null;
        }

        // X-axis - months
        const categories = this.props.messageTotals.map(x => moment(x.month).format("MMM"));
        // Control to render each channel as a line
        const chartSeriesItems = this.props.messageTotals[0].channels.map((channel, index) => {
            const nestedTooltipRender = (context: TooltipContext) => (<span><b>{context.point.value} {channel.channel} {context.point.category}</b></span>);
            return (
                <ChartSeriesItem type="line" data={this.getValuesForChannel(channel.channel)} name={channel.channel} key={index}>
                    <ChartSeriesItemTooltip render={nestedTooltipRender} />
                </ChartSeriesItem>
            )
        });
        return (
            <Chart>
                <ChartLegend position="top" orientation="horizontal" />
                <ChartValueAxis>
                    <ChartValueAxisItem title={{ text: this.props.t("MessagesTotalsByMonthChart.NumberOfMessagesLabel") }} />
                </ChartValueAxis>                
                <ChartCategoryAxis>
                    <ChartCategoryAxisItem categories={categories} />
                </ChartCategoryAxis>
                <ChartSeries>
                    {chartSeriesItems}
                </ChartSeries>
                <ChartTooltip />
            </Chart>
        );
    }

    private getValuesForChannel(channel: string): number[] {
        return this.props.messageTotals.map(x => {
            const channelMatch = x.channels.find(c => c.channel === channel);
            if (channelMatch) {
                return channelMatch.numberOfMessages;
            } else {
                return 0;
            }
        });
    }
    
}

export default translateComponent(MessageTotalsByMonthChart);



// WEBPACK FOOTER //
// ./src/components/Dashboard/MessageTotalsByMonthChart.tsx